export enum HyperlinkTarget {
    DEFAULT = 1,
    SAME_WINDOW = 2,
}
